/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetAppInitInitQueryResponse, GetAppInitInit403 } from "../models/GetAppInitInit";

export function getGetAppInitInitUrl() {
  const res = { method: 'GET', url: `/app-init` as const }
  return res
}

/**
 * @summary Get app init payload (user, client, stations, stations-groups)
 * {@link /app-init}
 */
export async function getAppInitInit(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetAppInitInitQueryResponse, ResponseErrorConfig<GetAppInitInit403>, unknown>({ method : "GET", url : getGetAppInitInitUrl().url.toString(), ... requestConfig })
  return res.data
}